
import React, { useState, useEffect } from 'react';
import { Container, Card, Button, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';

const AdminDashboard: React.FC = () => {
  const [adminSeason, setAdminSeason] = useState<number>(() => {
    return parseInt(localStorage.getItem('adminSelectedSeason') || '51');
  });

  useEffect(() => {
    const handleSeasonChange = () => {
      setAdminSeason(parseInt(localStorage.getItem('adminSelectedSeason') || '51'));
    };
    window.addEventListener('adminSeasonChanged', handleSeasonChange);
    return () => window.removeEventListener('adminSeasonChanged', handleSeasonChange);
  }, []);

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={8}>
          <Card className="shadow-sm home-card">
            <Card.Header as="h4" className="card-title-custom text-center">Admin Dashboard</Card.Header>
            <Card.Body>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <Link to="/admin/leagues">
                    <Button variant="primary" className="w-100">League Management (Create/Delete/Tribes)</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/scoring">
                    <Button variant="success" className="w-100">Enter Episode Scores</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/users">
                    <Button variant="info" className="w-100">Manage Users</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/edit-draft">
                    <Button variant="warning" className="w-100">Edit User Drafts</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/mock-draft">
                    <Button variant="outline-success" className="w-100">Mock Draft Simulator (Preview User Experience)</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/elimination-picks">
                    <Button variant="info" className="w-100">Manage Elimination Picks</Button>
                  </Link>
                </ListGroup.Item>
                {adminSeason < 51 && (
                  <ListGroup.Item>
                    <Link to="/admin/player-swaps">
                      <Button variant="warning" className="w-100">Manage Player Swaps</Button>
                    </Link>
                  </ListGroup.Item>
                )}
                {adminSeason < 51 && (
                  <ListGroup.Item>
                    <Link to="/admin/episode-deadlines">
                      <Button variant="info" className="w-100">Manage Medical Swap Deadlines</Button>
                    </Link>
                  </ListGroup.Item>
                )}
                <ListGroup.Item>
                  <Link to="/admin/clear-scores">
                    <Button variant="danger" className="w-100">Clear All Scores</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Link to="/admin/email">
                    <Button variant="primary" className="w-100">Email Center</Button>
                  </Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <a href="/MANUAL.md" target="_blank" rel="noopener noreferrer">
                    <Button variant="dark" className="w-100">View Operations Manual</Button>
                  </a>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
